/*
 * @Author: 张帮辉
 * @LastEditors: 赵泽文
 * @Date: 2022-05-17 14:57:05
 * @LastEditTime: 2022-05-26 11:42:28
 * @Description: 生产领料单model
 */
import type {
  IProductionProcessModel,
  IProductionProcessStore,
} from '@monorepo/types/process/productionMaterial/productionMaterial.types';
import { getToday } from '@monorepo/utils';
import { tableUpdate } from '@monorepo/utils';

const initState: IProductionProcessStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    date_type: 'CREATED_DATE',
    sort_order: 'CREATED_DESC',
    date: getToday(),
  },
  auditNo: '',
};

const productionProcess: IProductionProcessModel = {
  namespace: 'productionProcessStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default productionProcess;
